import actions from './actions'

export default function ContractPartnersReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTPARTNER:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTPARTNER:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTPARTNER:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTPARTNER:
      return {
        ...state,
        editing: { contractPartnerID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTPARTNER_RECIEVED:
    case actions.DELETE_CONTRACTPARTNER_RECIEVED:
      return {
        ...state,
        editing: { contractPartnerID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
